import React from "react";
import { cx } from "../../../../../styled-system/css";
import { LinkButton } from "../../../../elements/LinkButton/LinkButton";
import { ButtonVariants } from "../../../../shared/Button";
import { styles } from "./VinSearchFooter.style";

export interface VinSearchFooterProps {
  primaryText?: string | null; // eslint-disable-line sonarjs/no-redundant-optional -- Contentful returns explicit null
  secondaryText?: string | null; // eslint-disable-line sonarjs/no-redundant-optional -- Contentful returns explicit null
  sampleReport?: React.ReactNode;
  modalText?: React.ReactNode;
  additionalLinkText?: string;
  additionalLinkUrl?: string;
  ctaText?: string;
  ctaUrl?: string;
  ctaOnClick?: React.MouseEventHandler;
}

export const VinSearchFooter = (props: VinSearchFooterProps) => {
  const {
    primaryText,
    secondaryText,
    sampleReport,
    modalText,
    additionalLinkText,
    additionalLinkUrl,
    ctaText,
    ctaUrl,
    ctaOnClick,
  } = props;
  const hasLinks = !!(sampleReport || modalText || additionalLinkText || ctaText);
  const hasSecondaryContent = !!(secondaryText || hasLinks);
  const hasAnyContent = !!(primaryText || hasSecondaryContent);

  if (!hasAnyContent) {
    return null;
  }

  const renderLinks = (withLeadingSeparator: boolean) => {
    const items: React.ReactNode[] = [];

    if (sampleReport) {
      items.push(<React.Fragment key="sample-report">{sampleReport}</React.Fragment>);
    }

    if (modalText) {
      items.push(<React.Fragment key="modal-text">{modalText}</React.Fragment>);
    }

    if (additionalLinkText) {
      items.push(
        <React.Fragment key="additional-link">
          <LinkButton variant={ButtonVariants.Text} href={additionalLinkUrl} openInNewTab rel="noreferrer">
            {additionalLinkText}
          </LinkButton>
        </React.Fragment>,
      );
    }

    if (ctaText) {
      items.push(
        <React.Fragment key="cta">
          <LinkButton variant={ButtonVariants.Text} href={ctaUrl} onClick={ctaOnClick}>
            {ctaText}
          </LinkButton>
        </React.Fragment>,
      );
    }

    return items.map((item, index) => (
      <React.Fragment key={index}>
        {(index > 0 || withLeadingSeparator) && <span className={styles.separator()}> &bull; </span>}
        {item}
      </React.Fragment>
    ));
  };

  if (!primaryText) {
    return (
      <div className={cx(styles.wrapper(), styles.link())}>
        <span className={styles.primaryLine()}>
          {secondaryText}
          {renderLinks(!!secondaryText)}
        </span>
      </div>
    );
  }

  return (
    <div className={cx(styles.wrapper(), styles.link())}>
      <span className={styles.primaryLine()}>{primaryText}</span>
      {hasSecondaryContent && (
        <>
          <br />
          <span className={styles.secondaryLine()}>
            {secondaryText}
            {renderLinks(!!secondaryText)}
          </span>
        </>
      )}
    </div>
  );
};
